import React from 'react';
import { Modal } from 'antd';

type LeftPanelModalProps = {
	title: string;
	isOpen: boolean;
	onHideModal: () => void;
	children: React.ReactNode;
};

export const LeftPanelModal = ({
	title,
	isOpen,
	onHideModal,
	children,
}: LeftPanelModalProps) => {
	return (
		<Modal
			title={title}
			open={isOpen}
			footer={null}
			onCancel={onHideModal}
			destroyOnClose
			width={'60%'}
			centered
		>
			{children}
		</Modal>
	);
};
